(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('system-settings', {
            parent: 'application',
            url: '/system-settings',
            data: {
                pageTitle: 'global.menu.system-settings'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/system-settings/system-settings.html',
                    controller: 'SystemSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('global');
                	$translatePartialLoader.addPart('system-settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
